module.exports = __webpack_public_path__ + "img/ID.1606a804.svg";